module.exports = __webpack_public_path__ + "img/box2.c6e9fd72.png";